Auth = require 'db/auth'
Card = require 'models/card'
Controller = require 'controller'
ModelCache = require 'db/model-cache'
TrelloMarkdown = require '@atlassian/trello-markdown'
Util = require 'lib/util'
_ = require 'underscore'
TrelloEmoji = require('common/data/emoji').default

###
Optional Block Rules:
  blockquote    # >>>
  def           # [1] https://trello.com
  code          #     code
  fencedCode    # ```
  heading       # ## Heading
  hr            # ----
  lheading      # Heading followed by -----
  list          # - foo
  newline       # (Just separates paragraphs)
  paragraph     #

Optional Inline Rules:
  atMention     # @someone
  autolink      # <google.com> or <foo@bar.com>
  break         # single newline
  code          # `code`
  em            # *em*
  emoji         # :facepalm:
  link          # [something](http://...) or ![something](http:///)
  nolink        # [something] or ![something]
  strong        # **strong**
  reflink       # [something[1] or ![something][1]
  url           # https://trello.com
###

module.exports = window.TFM = new class

  constructor: ->
    defaults = { @lookupEmoji, @lookupCardInfo, @lookupMember }
    defaults.shouldOpenLinkInNewTab = Util.isExternalURL
    @description = new TrelloMarkdown(defaults)
    # TFM for comments
    @comments = new TrelloMarkdown(_.extend(
      restrict:
        block: [
          'blockquote'
          'code'
          'fencedCode'
          'hr'
          'list'
          'newline'
          'paragraph'
          'heading'
        ]
        inline: [
          'atMention'
          'autolink'
          'break'
          'code'
          'em'
          'email'
          'emailLink'
          'emoji'
          'link'
          'strong'
          'strikethrough'
          'url'
        ]
    , defaults))

    # Checklist Items
    @checkItems = new TrelloMarkdown(_.extend(
      inlineOnly: true
      restrict:
        inline: [
          'atMention'
          'autolink'
          'code'
          'em'
          'email'
          'emailLink'
          'emoji'
          'link'
          'strong'
          'strikethrough'
          'url'
        ]
    , defaults))

  lookupEmoji: (emoji, state) ->
    emoji = emoji.toLowerCase()
    state.textData?.emoji?[emoji] ? TrelloEmoji[emoji]

  lookupMember: (username, state) ->
    username = username.toLowerCase()

    if username in ['card', 'board']
      return [username, true]

    findByUsername = ->
      ModelCache.findOne('Member', 'username', username)

    findByFullName = ->
      ModelCache.findOne 'Member', (member) ->
        fullName = member.get('fullName')
        if fullName
          _.chain(fullName.toLowerCase().split(/\s+/))
           .filter (part) -> part.length >= 2
           .contains(username)
           .value()
         else
          false

    member = findByUsername() ? findByFullName()
    if member?
      [member.get('fullName'), Auth.isMe(member)]
    else if /^[a-z0-9_]{3,}/.test(username)
      # Even if we couldn't find a member record, assume that it's still a
      # mention if it looks like a username.  It's possible, e.g. in a
      # notification, that we haven't loaded the member that's being mentioned
      [username, false]
    else
      [null, false]

  lookupCardInfo: (idShort, state) ->
    idShort = parseInt(idShort, 10)
    idBoard = state?.board?.id

    ###
    If it was passed a boardId, we use that boardId to find the card, otherwise we use
    the current boardId. If we find a card, it means that the desired card is loaded to
    the model cache, and we use its URL and title. Otherwise, we create a URL based on
    what it should be, which redirects to the correct one when clicked on. However,
    the link title is still called "Card <cardNum>," as it has not been loaded into the model cache.
    ###
    if !idBoard? && (currentBoard = Controller.getCurrentBoard())?
      idBoard = currentBoard.id
    card = ModelCache.findOne 'Card', (card) ->
      card.get('idBoard') == idBoard && card.get('idShort') == idShort
    if card?
      title: card.get('name')
      url: Controller.getCardUrl(card)
    else
      cardTitle = "Card #{idShort}"
      title: cardTitle
      url: Controller.getCardUrlWithoutModels(idBoard, idShort, cardTitle)



// WEBPACK FOOTER //
// ./app/scripts/lib/markdown/tfm.coffee